module.exports = __webpack_public_path__ + "static/media/Ali Alomran.59be3c2e.jpg";